angular.module('ikeweb.user').controller('SignUpController', ['$scope', '$location', '$stateParams', 'signupService', 'loginService',

    function signup($scope, $location, $stateParams, signupService, loginService) {

        if (loginService.getLoggedInUser()) {
            $location.path('gallery');
        }

        var inProgress = false;
        $scope.user = {};

        function signup() {

            $scope.user.email = $scope.user.email.toLowerCase();

            var user = {
                email: $scope.user.email,
                password: $scope.user.password,
                token: $stateParams.token
            };

            inProgress = true;

            return signupService.signup(user)
                .then(function() {
                    $location.path('gallery');
                    inProgress = false;
                }, function() {
                    inProgress = false;
                });
        }

        this.inProgress = function() {
            return inProgress;
        };

        this.signup = signup;
        this.loggedIn = loginService.isLoggedIn;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/signup/signup.controller.js
// module id = 472
// module chunks = 0